<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-search-settings': state.visibleSearchByKeyword},
    {'is-visible-menu':state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft},
    {'is-focused-input':state.isFocusInput}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentName="'SPQAList'"
      :parentVisibleMenu="state.visibleMenu"
      @searchByKeyword="group1.searchWithOptions({ from_menu: true, search_executed: true })"
      @closeMenu="state.visibleMenu = false"
    />

    <!-- 詳細検索 -->
    <transition name="popup">
      <SPQASearchDetail
        v-if="state.visibleSearchDetail"
        :startLoading="state.visibleSearchDetail"
        :parentName="'SPQAList'"
        @searchDetail="group1.searchWithOptions"
        @closeSearchDetail="state.visibleSearchDetail = false"
      />
    </transition>

    <!-- 並び順設定 -->
    <transition name="popup">
      <SPQASearchOrderSetting
        v-if="state.visibleSearchOrderSettings"
        @closeSearchOrderSettings="state.visibleSearchOrderSettings = false"
      />
    </transition>

    <!-- 表示設定 -->
    <transition name="popup">
      <SPQASearchDisplaySetting
        v-if="state.visibleSearchDisplaySettings"
        @closeSearchDisplaySettings="state.visibleSearchDisplaySettings = false"
      />
    </transition>

    <!-- 絞り込み設定 -->
    <transition name="popup">
      <SPQASearchExtract
        v-if="state.visibleSearchExtract"
        :parentGroup1="group1"
        @closeSearchExtract="state.visibleSearchExtract = false"
      />
    </transition>

    <!-- ノートの選択（一覧画面用） -->
    <transition name="popup">
      <SPSelectNoteForList
        v-if="state.visibleSelectNote"
        :type="'qa'"
        :typeId="group1.targetQaIdToSelectNote"
        :startLoading="state.visibleSelectNote"
        @closeSelectNote="state.visibleSelectNote = false"
      />
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-1"
          :class="{'is-active': state.visibleSearchByKeyword}"
          @click="group1.onOpenSearchWindowButtonClicked"
        >
          <FontawesomeIcon :icon="['fas','search']" class="icn icn-closed"/>
          <FontawesomeIcon :icon="['fas','times']" class="icn icn-opened"/>
        </div>
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true;state.visibleSearchByKeyword = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        @click="state.visibleSearchExtract = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>

      <!-- 検索ウインドウ -->
      <SPSearchUI 
        :screenType="'qa'"
        :isAlertShown="false"
        :isSearchExecutedAtSameScreen="true"
        @search="group1.searchWithOptions"
        @searchDetail="group1.searchWithOptions"
        @searchResetOptions="group1.searchResetOptions"
        @openSearchDetail="state.visibleSearchDetail = true;state.visibleSearchByKeyword = false"
        @handleFocusOutInput="state.isFocusInput = false"
        @handleFocusInput="state.isFocusInput = true"
      />

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>Q&amp;A・事例 検索結果</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="main-heading-row main-heading-result">
              <div class="main-heading-result-num">{{ group1.totalItemsDisp }}件</div>
              <div role="button" class="main-heading-result-link"
                @click="group1.onSaveSearchConditionClicked()"
              >検索条件の保存</div>
            </div>
            <div class="main-heading-row main-heading-menu column">
              <div class="main-heading-menu-item column-item col-8">
                <div role="button" class="main-heading-menu-link"
                  @click="state.visibleSearchOrderSettings = true"
                >
                  並び順 - {{ group1.orderDisp }}
                  <FontawesomeIcon :icon="['fas','angle-down']" size="lg" class="icn down" />
                </div>
              </div>
              <div class="main-heading-menu-item column-item col-4">
                <div role="button" class="main-heading-menu-link"
                  @click="state.visibleSearchDisplaySettings = true"
                >
                  表示設定
                </div>
              </div>
            </div>
          </div>
          <div class="main-container pb0" id="scroll-target"
            @scroll="handleScroll"
          >
            <FontawesomeIcon v-if="!group1.isQAListLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
            <template v-else>

              <p v-if="!group1.listExists" class="txt ml20 mr20 mt20">キーワードに合致する検索結果がありませんでした。<br>検索キーワードを変更して再度検索してください。</p>
              <template v-else>
                <ul class="list-result">

                  <li v-for="(item, index) in group1.list" :key="index" class="list-result-item" :id="'list-item-' + item.id">
                    <div class="list-result-item-main">
                      <div class="list-result-title"><a @click.stop.prevent="group1.onQATitleInListClicked(item.book_id, item.title, item.id)" v-html="item.title"></a></div>
                      <p v-show="!group1.is_hidden_text" v-html="item.text" class="list-result-text"></p>
                      <div class="list-result-note">
                        <span v-if="!group1.is_hidden_current && item.citation_date !== ''" 
                          class="list-result-sup">内容現在：{{ item.citation_date }}</span>
                        <span v-if="!group1.is_hidden_note && item.note_count > 0"
                          @click="group1.onNoteInListClicked(item.id)"
                          class="list-result-link"
                        >ノート（{{ item.note_count }}）</span>
                      </div>
                      <div class="list-result-note">
                        <a v-show="!group1.is_hidden_book"
                        @click.stop.prevent="group1.onBookInListClicked(item.book_id, item.title)"
                        class="list-result-link">{{ item.book_name }}</a>
                      </div>
                    </div>

                    <div class="list-result-item-sub">
                      <ButtonViewLater
                        :afterId="item.after_id"
                        :paramId="item.id"
                        :paramKey="'qa'"
                        :gaClass="'ga-qa-list-view-later'"
                        @onViewLaterChanged="group1.onViewLaterChanged"
                      />
                    </div>
                  </li>


                </ul>
                <SPPagenation
                  v-if="group1.isPaginationShown"
                  :count="group1.totalItems"
                  :per_page="group1.perPage"
                  :currentPage="group1.currentPage"
                  @changePage="group1.onPageChanged"
                />
              </template>
            </template>
 
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api'

import SPSearchUI from '@/components/sp/partial/SPSearchUI.vue'
import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPQASearchDisplaySetting from '@/components/sp/popup/SPQASearchDisplaySetting.vue'
import SPQASearchExtract from '@/components/sp/popup/SPQASearchExtract.vue'
import SPQASearchOrderSetting from '@/components/sp/popup/SPQASearchOrderSetting.vue'
import SPQASearchDetail from '@/components/sp/popup/SPQASearchDetail.vue'
import SPSelectNoteForList from '@/components/sp/popup/SPSelectNoteForList.vue'
import SPNoteCreate from '@/components/sp/popup/SPNoteCreate.vue'
import SPQASearchDetailBookList from '@/components/sp/popup/SPQASearchDetailBookList.vue'
import SPQASearchDetailCourtList from '@/components/sp/popup/SPQASearchDetailCourtList.vue'
import SPQASearchDetailPastYearBookList from '@/components/sp/popup/SPQASearchDetailPastYearBookList.vue'
import SPQASearchDetailPackageList from '@/components/sp/popup/SPQASearchDetailPackageList.vue'
import SPBasicToast from '@/components/sp/popup/SPBasicToast.vue'
import SPPagenation from '@/components/sp/partial/SPPagenation.vue'

import * as logicQAList from '@/logic/qa/QAList'

export default defineComponent({
  components: {
    SPSearchUI,
    SPMenu,
    SPQASearchDisplaySetting,
    SPQASearchExtract,
    SPQASearchOrderSetting,
    SPQASearchDetail,
    SPSelectNoteForList,
    SPNoteCreate,
    SPQASearchDetailBookList,
    SPQASearchDetailCourtList,
    SPQASearchDetailPastYearBookList,
    SPQASearchDetailPackageList,
    SPBasicToast,
    SPPagenation
  },
  setup (props, context) {

    const { group1, state } = logicQAList.getGroup(props, context)
   
    return {
      group1,
      state
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height * 2);
  }
}
.list-result {
  &-title {
    padding-right: 36px;
  }
}
.menu-btn {
  &-1 {
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}

.is-visible-search-settings {
  .menu-btn {
    // transform: translate3d(0,-206px,0);
    transform: translate3d(0,-271px,0);
    &-1 {
      .icn {
        transition: all .2s ease;
      }
      .icn-opened {
        opacity: 1;
      }
      .icn-closed {
        opacity: 0;
      }
    }
  }
  .search-settings {
    transform: translate3d(0,0,0);
    box-shadow: 0 -8px 8px rgba(0,0,0,.16);
  }
}
</style>
